
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gBTbgNHPntKnFsX5sVWZfiTakL8b_C3ndMJ_mfczrRZYMeta } from "/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexCZxd9mdirbY_4500zM_2EY23TXqJed6eMaV0IylzP5V1IMeta } from "/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchoPClWBz9dPuUtZa0cbyzslQjxZ9jCTUovCi0AN3jvCsMeta } from "/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexQ2cvKiII9J8cCNtqsV5mD3sFUbWtT9uw5I9Yu2dK620Meta } from "/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93YlmBAOKFiTJ_45IZGZa8WXcjjo_MQx_jiq4M_45ESOtzBv0Meta } from "/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexUz_455eSCGxRrWa25SQZvMIi0grCnzQY6ptGDeF6iCSzcMeta } from "/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_935ObF_45xOJm3XTNuYD0eKHtYejrC_45Ds1EOTZcw8Ih9zRUMeta } from "/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexYC_45jDzd8G0_45xb6bfPA3GtNI1aQnyN6hhwWeBzelwMkoMeta } from "/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93Q9Eki25kyFftoqngDdskGk35O8HpUxXlpTBU3eYe1EAMeta } from "/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index7BcK2kvvlxgd9evbFY_45tAC44fx3C7BugJfrfvSkfzt4Meta } from "/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexfM_Ptkr8lB8_X0_451xZ6gjhbONIwDU7ZBa_45dAh_456W8mQMeta } from "/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexUz_455eSCGxRrWa25SQZvMIi0grCnzQY6ptGDeF6iCSzcMeta || {},
    component: () => import("/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexYC_45jDzd8G0_45xb6bfPA3GtNI1aQnyN6hhwWeBzelwMkoMeta || {},
    component: () => import("/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index7BcK2kvvlxgd9evbFY_45tAC44fx3C7BugJfrfvSkfzt4Meta || {},
    component: () => import("/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexfM_Ptkr8lB8_X0_451xZ6gjhbONIwDU7ZBa_45dAh_456W8mQMeta || {},
    component: () => import("/codebuild/output/src320795/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]